import styled from 'styled-components'
import measures from 'globals/measures'
import colors from 'globals/colors'

interface ClientStatusWrapperProps {
  status: 'activated' | 'pending_partner_check' | 'canceled'
}

export const ClientStatusWrapper = styled.div<ClientStatusWrapperProps>`
  height: 24px;
  line-height: 24px;
  color: ${(props) => colorFromStatus(props.status)};
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  
  @media(max-width: ${measures.mobileThreshold}px) {
    font-size: 16px;
    margin-bottom: 2px;
  }
  
  & > span {
    height: 8px;
    width: 8px;
    background: ${(props) => colorFromStatus(props.status)};
    border-radius: 50%;
    margin-left: 8px;
  }
`

export const colorFromStatus = (status: 'activated' | 'pending_partner_check' | 'canceled') => {
  switch (status) {
    case 'activated':
      return colors.blueGreen
    case 'pending_partner_check':
      return colors.apricot
    case 'canceled':
      return colors.reddishPink
  }
}
